var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 83,
    viewBox: "0 0 72 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 74.1V43.2L6 27.6V58.5L33 74.1ZM39 74.1L66 58.5V27.5L39 43.2V74.1ZM36 82.7L0 62V21L36 0.299988L72 21V62L36 82.7ZM52.4 28.5L62.6 22.6L36 7.19999L25.8 13.1L52.4 28.5ZM36 38.1L46.4 32L19.7 16.6L9.3 22.6L36 38.1Z",
    fill: "#595F77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackages);
export default __webpack_public_path__ + "static/media/packages.b1020af35a52b22cd57b9d29f7228fef.svg";
export { ForwardRef as ReactComponent };